import React, { useState } from 'react';
import { Menu } from 'lucide-react';

import { Button } from 'shadcn/components/ui/Button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from 'shadcn/components/ui/Dialog';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from 'shadcn/components/ui/DropdownMenu';

/**
 * @param {Object} props
 * @param {string} [props.facilityName]
 * @param {boolean} [props.isEnabled=true]
 * @param {() => void} [props.onToggleEnabled]
 * @param {() => void} [props.onDelete]
 */
export function SubstitutionRuleActionsMenu({
    facilityName,
    isEnabled = true,
    onDelete = () => {},
    onToggleEnabled = () => {},
}) {
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const facilityLabel = facilityName ? ` (${facilityName})` : '';

    const handleConfirmDelete = () => {
        setIsDeleteDialogOpen(false);
        onDelete();
    };

    return (
        <>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button type="button" variant="ghost" size="icon" aria-label="Open actions menu">
                        <Menu className="h-4 w-4" />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                    <DropdownMenuItem onSelect={onToggleEnabled}>
                        {isEnabled ? 'Disable' : 'Enable'} Rule for Facility{facilityLabel}
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                    <DropdownMenuItem variant="destructive" onSelect={() => setIsDeleteDialogOpen(true)}>
                        Delete Rule
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
            <Dialog open={isDeleteDialogOpen} onOpenChange={setIsDeleteDialogOpen}>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>Delete substitution rule?</DialogTitle>
                        <DialogDescription>
                            This permanently deletes this substitution rule and cannot be undone.
                        </DialogDescription>
                    </DialogHeader>
                    <DialogFooter>
                        <DialogClose asChild>
                            <Button type="button" variant="outline">
                                Cancel
                            </Button>
                        </DialogClose>
                        <Button type="button" variant="destructive" onClick={handleConfirmDelete}>
                            Delete Rule
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    );
}

SubstitutionRuleActionsMenu.displayName = 'SubstitutionRuleActionsMenu';
